<template>
  <el-dialog
    :visible="visible"
    width="100%"
    :show-close="false"
    >
    <div class="mobile-menu">
     <div class="menu-header">
      <img class="logo" src="@/assets/images/logo.webp" alt="">
      <img @click="handleClose" class="close-icon" src="@/assets/icons/close.svg" alt="">
     </div>
      <div class="menu-content">
      <div class="title">{{ $t('navigation.menu') }}</div>
      <ul>
        <li v-for="item in navList" :key="item.path">
          <a v-if="item.path === '/feedback'" href="javascript:void(0);" @click="showFeedback">
            {{ $t(item.meta.title) }}
            <img src="@/assets/icons/right.svg" alt="">
          </a>
          <a v-else :href="item.path">
            {{ $t(item.meta.title) }}
            <img src="@/assets/icons/right.svg" alt="">
          </a>
        </li>
      </ul>
     </div>
     <div class="language">
      <div class="title">{{ $t('navigation.switchLanguage') }}</div>
      <div class="language-content">
        <span :class="{'active':language === 'en'}" @click="handleChangeLanguage('en')">English/EN</span>
        <span  :class="{'active':language === 'zh'}" @click="handleChangeLanguage('zh')">Chinese/CN</span>
      </div>
     </div>
    </div>

  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      language: this.$i18n.locale,
      navList: this.$router.options.routes.filter(item => !item.meta.hidden),
    };
  },
  methods: {
    handleClose() {
      this.$emit('close')
    },
    handleChangeLanguage(language) {
      this.$i18n.locale = language;
      this.language = language;
      localStorage.setItem('lang', language);
    },
    showFeedback() {
      this.handleClose();
      this.$bus.$emit('showFeedback');
    }
  }
}
</script>

<style lang='scss' scoped>
::v-deep .el-dialog {
  height: 100%;
  margin: 0px!important;
  border-radius: 0px;
  .el-dialog__header {
    display: none;
    
  }
  .el-dialog__body {
    padding: 0px;
    height: 100%;
  }
  .mobile-menu {
    padding: 12px 16px;
    position: relative;
    height: 100%;
    .menu-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 17px;
      .logo {
        width: 64px;
      }
      .close-icon {
        width: 16px;
        padding:16px;
        box-sizing:content-box
      }
    }
    .menu-content {
      .title {
        font-size: 15px;
        line-height: 19px;
        margin-bottom: 25px;
        color: #0A0A0A;
      }
      ul {
        li {
          margin-bottom: 15px;
          a {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 24px;
            font-weight: 500;
            line-height: 29px;
            color: #050505;
            img {
              width: 20px;
              padding: 6px;
              box-sizing: content-box;
            }
          }
        }
      }
    }
    .language {
      position: absolute;
      bottom: 64px;
      left: 0px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      padding: 0px 16px;
      .title {
        font-size: 15px;
        line-height: 19px;
        color: #0A0A0A;
      }
      .language-content {
        margin-left: 35px;
        display: flex;
        align-items: center;
        padding: 4px;
        gap: 8px;
        border-radius: 6px;
        background: #00000040;
        span {
          display: inline-block;
          padding: 4px 13px;
          font-size: 12px;
          line-height: 17px;
          border-radius: 2px;
          cursor: pointer;
        }
        .active {
          background: #fff;
          color: #404040;
        }
      }
    }
  }
}
</style>